import { Navigate, useLocation, useParams } from 'react-router-dom';
import { clipStudioPath } from '@/lib/freecut-studio/studioPath';

/** Old FreeCut Studio links (`/clips/:id/freecut`) open AutoCut Studio. */
const RedirectLegacyClipStudio = () => {
  const { id = '' } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${clipStudioPath(id)}${search}${hash}`} replace />;
};

export default RedirectLegacyClipStudio;
